// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q21j","index":"styles_index__1yBab"};